import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';
import { SplitLayout } from '../layouts/SplitLayout';
import { TemplateSection } from './Section';

export type ContactTemplateProps = {
  /** A PageHeader. */
  header: ReactNode;
  /**
   * The form: topic RadioGroup (cards), Inputs with visible labels, one primary Send. Optional: a
   * page that only offers an email address puts it in `side` (or here as a Card) instead.
   */
  form?: ReactNode;
  /** A Card with the email as selectable text and the legal entity. */
  side?: ReactNode;
  /** Questions people ask before writing, as an Accordion, with its heading. Pages with FAQPage JSON-LD must show it. */
  faq?: { title: ReactNode; content: ReactNode };
  className?: string;
};

/** Contact and recruiter contact pages. */
export function ContactTemplate({ header, form, side, faq, className }: ContactTemplateProps) {
  return (
    <PageContainer className={className}>
      <div className="flex flex-col gap-jc-block py-jc-section">
        {header}
        <SplitLayout aside={side} asideWidth="side">
          <div className="flex max-w-2xl flex-col gap-jc-block">
            {form}
            {faq ? (
              <TemplateSection id="faq" title={faq.title}>
                {faq.content}
              </TemplateSection>
            ) : null}
          </div>
        </SplitLayout>
      </div>
    </PageContainer>
  );
}
